module.exports = __webpack_public_path__ + "img/mc.e9cc669.svg";